import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const asignarSucursalBox = async ({ params, token, callbacks }) => {
    const response = await connection({ method: 'POST', url: `${ENTITY_URL.PERSONA.ASSIGN_BRANCH_AND_BOX_TO_PERSON}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default asignarSucursalBox;